import { useEffect, useRef } from 'react';
// ВАЖНО: импортируем SDK как модуль (Vite собирает его самодостаточно вместе с
// babel-хелперами). Раньше SDK грузился UMD-скриптом с unpkg, но тот UMD-бандл
// НЕ бандлит @babel/runtime/helpers (typeof и др.) — выносит во внешние зависимости.
// При загрузке через <script> они не резолвятся → _typeof === undefined →
// "t is not a function" в билдере URL внутри SDK → OneTap.render() падает и виджет
// отваливается по timeout. Импорт через бандлер эту проблему устраняет (проверено).
import * as VKIDNS from '@vkid/sdk';

const VKID: any = VKIDNS;

/**
 * VK ID One Tap логин. Работает в responseMode Callback — без редиректа:
 * после успешного входа шлёт code на /api/vk (создаёт сессию) и зовёт onSuccess.
 */
export function VkLogin({ onSuccess }: { onSuccess: () => void }) {
  const containerRef = useRef<HTMLDivElement>(null);
  const successRef = useRef(onSuccess);
  successRef.current = onSuccess;

  useEffect(() => {
    if (!containerRef.current) return;

    // VK ID SDK встраивает трекер top.mail.ru (грузит https://mytopf.com/js/code.js
    // и шлёт туда данные пользователя). Домен режут блокировщики/сети → лишний
    // ERR_CONNECTION_CLOSED в консоли. SDK инжектит трекер только если ещё нет
    // элемента с id="tmr-code" — кладём пустышку: трекер не грузится, данные
    // пользователя туда не уходят.
    if (!document.getElementById('tmr-code')) {
      const stub = document.createElement('script');
      stub.id = 'tmr-code';
      stub.type = 'text/javascript';
      document.head.appendChild(stub);
    }

    VKID.Config.init({
      app: 54414521,
      redirectUrl: 'https://auth.tarsapp.net/api/vk/callback',
      responseMode: VKID.ConfigResponseMode.Callback,
      source: VKID.ConfigSource.LOWCODE,
      scope: 'vkid.personal_info email',
    });

    const oneTap = new VKID.OneTap();

    // Обработчики навешиваем ДО render() — на всякий случай, чтобы любой возможный
    // бросок render() не оборвал навешивание LOGIN_SUCCESS.
    oneTap.on(VKID.WidgetEvents.ERROR, (e: any) => console.error('VK Auth error:', e));
    oneTap.on(VKID.OneTapInternalEvents.LOGIN_SUCCESS, (payload: any) => {
      fetch('/api/vk', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({
          code: payload.code,
          device_id: payload.device_id,
          state: payload.state || Math.random().toString(36).substring(2),
        }),
      })
        .then((res) => {
          if (!res.ok) throw new Error('auth failed');
          return res.json();
        })
        .then(() => successRef.current())
        .catch((err) => console.error('Backend auth error:', err));
    });

    try {
      oneTap.render({
        container: containerRef.current,
        showAlternativeLogin: true,
        styles: { borderRadius: 10, height: 46 },
      });
    } catch (e) {
      console.warn('VK OneTap render threw (ignored):', e);
    }
  }, []);

  return <div ref={containerRef} id="vk-one-tap" className="w-full" />;
}
